import { OrganizerEventList } from '../components/organizer-event-list';

export function OrganizerEvents() {
  return <OrganizerEventList />;
}
